// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + chunkId + "." + {"276": "0643fcb2","850": "3c1b9d78",}[chunkId] + ".css"
}